import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import userIcon from "../../assets/avatar.png"; // Default user icon
import Loader from "../../components/loader";
import { useModuleSettings } from "../../components/moduleSettingsContext/ModuleSettingsContext";
import { courseReview } from "../../slices/courseSlice";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../../components/spinner";
import { decrypt } from "../../common/enc_dec";
import StarRating from "../../components/startRating";
import { formatTimestamp } from "../../common/timeStampConverter";

const CourseReviews = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { courseReviewList, loading, error } = useSelector((state) => state.course);
    // const { page, setPage, limit } = useModuleSettings();
    const { data } = location?.state || {};
    const [reviews, setReviews] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(7);
    const [timeZone, setTimeZone] = useState('');
    const queryParams = new URLSearchParams(location.search);
    const _id = decrypt(decodeURI(queryParams.get("id")));

    useEffect(() => {
      // Get the user's timezone when the component mounts
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setTimeZone(userTimeZone);
    }, []);

    useEffect(() => {
        dispatch(courseReview({ page, limit, course_id: _id }));
    }, [dispatch, page, limit]);

    useEffect(() => {
        if (courseReviewList?.data?.length > 0) {
            setReviews((prevReviews) => [...prevReviews, ...courseReviewList.data]);
            setHasMore(courseReviewList.data.length >= limit);
        } else {
            setHasMore(false);
        }
        return ()=>{
            setReviews([]);
        }
    }, [courseReviewList, limit]);

    const fetchMoreReviews = () => {
        setPage((prevPage) => prevPage + 1);
    };

    // if (!reviews) {
    //     return <Loader />;
    // }

    // if (error) {
    //     return <div>Error loading reviews: {error.message}</div>;
    // }

    // if (reviews.length === 0) {
    //     return <div>No reviews available</div>;
    // }
    

    return (
        <>
            <Helmet>
                <title>GUARDING.TECH | Reviews</title>
            </Helmet>

            <div className="content-page">
                <div className="col-md-12 col-xl-12 mt-1">
                    <div className="widget-rounded-circle card">
                        <div className="card-body px-4">
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", marginBottom: "10px" }}>
                                <button className="btn btn-sm" onClick={() => navigate(-1)}>
                                    <i className="fe-arrow-left font-22 avatar-title text-secondary" />
                                </button>
                                <div>
                                    <h3 className="text-info text-center">{data.name}</h3>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "10px" }}>
                                <h3 className="text-info text-capitalize">Course Reviews</h3>
                            </div>

                            <InfiniteScroll
                                dataLength={reviews?.length}
                                next={fetchMoreReviews}
                                hasMore={hasMore}
                                loader={<Spinner />}
                                endMessage={<p style={{ textAlign: "center" }}>No more reviews</p>}
                                style={{overflow:"inherit",height:"auto"}}
                            >
                                <div className="review-list">
                                    {reviews?.map((review) => (
                                        <div key={review?.id} className="review-item card mb-3">
                                            <div className="row align-items-center">
                                                <div className="col-9 d-flex align-items-center">
                                                    <img
                                                        src={review?.user_course_review?.image || userIcon}
                                                        alt={review?.user_course_review?.full_name || "User"}
                                                        className="rounded-circle"
                                                        style={{ width: '50px', height: '50px', marginRight: '10px' }}
                                                    />
                                                    <div>
                                                        <h5 className="mb-0">{review?.user_course_review?.full_name || "Anonymous User"}</h5>
                                                        <div className="rating" style={{ color: '#ffc107' }}>
                                                            <StarRating rating={review?.rating} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-3 text-right">
                                                    <small className="text-muted">
                                                        {formatTimestamp(review?.review_date,"ddd, D MMM [at] HH:mm",timeZone)}
                                                        {/* {review?.review_date ? moment.utc(review?.review_date).format("ddd, D MMM [at] HH:mm") : "Date not available"} */}
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <p>{review?.review || "No review provided"}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CourseReviews;